import { Theme } from "../../../../components/constants";

export default {
    logo: {
        width: "169px", 
        height: "85px",
    },
    imageSection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "80px",
        textAlign: "center",
    },
    sectionLabelContainer: {
        marginTop: "50px",
    },
    sectionLabel: {
        fontSize: "32px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    bottomRow: {
        display: "flex",
        gap: "20px",
        marginTop: "20px",
        width: "100%",
        justifyContent: "space-evenly"
    },
    featureDiv: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    featureText: {
        fontSize: "14px",
    },
}
